export const reservationInvoicePanel = {
  loadingVerifying: "Vérification…",

  status: {
    draft: "Brouillon",
    sent: "Émise",
    processing: "En cours de traitement",
    pending: "En attente",
    error: "Erreur",
    corrected: "Rectifiée",
    voided: "Annulée",
  },

  common: {
    cancel: "Annuler",
    understood: "Compris",
    optional: "facultatif",
    optionalParen: "(facultatif)",
    sending: "Envoi…",
    saving: "Enregistrement…",
    deleting: "Suppression…",
    emitting: "Émission…",
    creating: "Création…",
    retrying: "Nouvelle tentative…",
  },

  issued: {
    title: "Factures émises",
    rectifOf: "Rectification de {code}",
    viewPdf: "Voir le PDF",
    sendByWhatsapp: "Envoyer via WhatsApp",
    correctTitle: "Rectifier (facture rectificative)",
    voidTitle: "Annuler (facture rectificative)",
  },

  empty: {
    guestRequested: "Le client a demandé sa facture",
    noInvoice: "Aucune facture émise",
    linkSent: "Lien envoyé",
    requested: "Demandée",
    requestedSub: "Vérifiez ses informations et émettez la facture, ou envoyez-lui le lien pour confirmer.",
    sub: "Envoyez le lien au client ou créez directement la facture.",
    copyLinkTitle: "Copier le lien dans le presse-papiers",
    sendLink: "Envoyer le lien",
    createInvoice: "Créer la facture",
    configureHint: "Configurez vos informations de facturation pour activer cette fonctionnalité.",
  },

  next: {
    title: "Cette réservation possède déjà sa facture",
    sub: "Y a-t-il eu un frais ultérieur ? Créez une autre facture pour cette réservation : elle n'inclura que les nouveaux frais (l'hébergement déjà facturé n'est pas répété).",
    button: "Créer une autre facture pour cette réservation",
  },

  card: {
    draftRefTitle: "Référence interne du brouillon. Le numéro fiscal est attribué à l'émission.",
  },

  draft: {
    emptyHint: 'Ajoutez au moins un frais sous <b>« Nouveaux frais »</b> pour émettre cette facture.',
    noteLead: "Brouillon — modifiez les informations ou ajoutez des frais ci-dessus ; le numéro et la date sont attribués à l'<b>émission</b>.",
    nextSequential: "Prochain numéro séquentiel",
    estimated: "estimé",
    noteFoot: "Le numéro n'est pas définitif : le premier à émettre l'obtient.",
    confirmEmit: "Confirmer et émettre la facture",
    previewPdf: "Aperçu du PDF",
    sendQuote: "Envoyer le devis",
    edit: "Modifier la facture",
    discard: "Abandonner",
  },

  // Lignes du document en cours : ce que l'on vérifie AVANT d'émettre.
  concepts: {
    title: "Lignes du document",
    item: "Article",
    qty: "Qté",
    unitPrice: "Prix unit.",
    vat: "TVA",
    amount: "Montant",
    linesTotal: "Total des lignes",
    foot: "Voici comment le détail apparaîtra sur la facture. Le PDF contient le détail complet.",
    mismatch: "Le total des lignes ({lines}) ne correspond pas au total du document ({total}). Vérifiez-le avant d'émettre.",
  },

  // Lo cobrado y lo que queda a deber. Mismas palabras y mismo orden que el
  // pie del PDF, para que leer la pantalla y leer la factura sea lo mismo.
  cobro: {
    total: "Total du document",
    nothing: "Aucun paiement enregistré",
    due: "Reste à payer",
    assumed: "Aucun paiement n'est enregistré sur cette réservation. Le montant est considéré comme encaissé d'après le mode de paiement indiqué, et le PDF l'indiquera de même. Si vous n'avez pas encore été payé, enregistrez le paiement ou changez le mode de paiement.",
  },

  actions: {
    sendWhatsapp: "Envoyer WhatsApp",
    correct: "Rectifier",
    void: "Annuler",
    refresh: "Actualiser",
    retry: "Réessayer",
    editData: "Modifier les informations",
    delete: "Supprimer",
  },

  wa: {
    title: "Envoyer la facture via WhatsApp",
    desc: "La facture <strong>{code}</strong> sera envoyée au client au format PDF via WhatsApp.",
    issuedFallback: "émise",
    checkPhone: "Le téléphone du client associé à la réservation sera utilisé",
    checkPdf: "Le document sera envoyé au format PDF",
    send: "Envoyer la facture",
  },

  sendLink: {
    title: "Envoyer le lien de facturation",
    desc: "Un <strong>lien WhatsApp</strong> sera envoyé au client pour confirmer ses informations fiscales et télécharger sa facture.",
    checkNoInvoice: "Aucune facture n'est encore émise : le client reçoit uniquement le lien",
    button: "Envoyer le lien",
  },

  retryModal: {
    title: "Réessayer l'émission",
    desc: "Nous tenterons à nouveau d'<strong>émettre cette facture</strong> avec les informations actuelles.",
    check1: "Elle est renvoyée à l'administration de facturation électronique",
    check2: "En cas de succès, le numéro fiscal définitif est attribué",
  },

  voidModal: {
    doneTitle: "Facture annulée — Avoir émis",
    creditNoteIssued: "Avoir <strong>{code}</strong> émis",
    chargesReleased: "Les frais supplémentaires ont été libérés",
    clientCanRequest: "Le client peut demander à nouveau la facture",
    doneHint: "Ajoutez ou corrigez les frais en attente et créez une nouvelle facture.",
    formTitle: "Annuler la facture / Émettre une facture rectificative",
    formDesc: "Utilisez cette option lorsque vous devez <strong>ajouter ou modifier des services/montants</strong>. Un <strong>avoir</strong> sera émis pour annuler la facture d'origine, et vous pourrez créer une nouvelle facture avec les frais corrects.",
    stepAnnul: "Une facture rectificative fiscal est émis pour annuler {code}",
    stepFree: "Les frais sont libérés pour ajout ou correction",
    stepNewNumber: "Une nouvelle facture est créée avec le numéro suivant",
    notice: "Pour corriger uniquement le NIF, le nom ou l'adresse sans modifier les montants, utilisez plutôt <strong>Rectifier les informations</strong>.",
    voiding: "Émission de la facture rectificative…",
    confirm: "Annuler et émettre la facture rectificative",
  },

  edit: {
    titleDraft: "Modifier la facture",
    titleClient: "Modifier les informations du client",
    descDraft: "Les modifications sont enregistrées instantanément. Les informations fiscales sont validées sans émission.",
    descSent: "Lors de l'enregistrement, l'envoi sera automatiquement relancé.",
    type: "Type",
    individual: "Particulier",
    individualSub: "Personne physique",
    company: "Entreprise",
    companySub: "Personne morale",
    legalName: "Raison sociale",
    fullName: "Nom complet",
    legalNamePlaceholder: "Raison sociale de l'entreprise",
    fullNamePlaceholder: "Prénom et nom",
    country: "Pays",
    countryPlaceholder: "Sélectionnez le pays du client",
    taxRequiredOnEmit: "requis à l'émission",
    taxIdPlaceholderCompany: "NIF / CIF de l'entreprise",
    taxIdPlaceholderIndividual: "DNI / NIE · vide = consommateur final",
    email: "E-mail",
    emailPlaceholder: "email@example.com",
    phone: "Téléphone",
    phonePlaceholder: "+34 600 000 000",
    fiscalAddress: "Adresse fiscale",
    addressPlaceholder: "Rue et numéro",
    city: "Ville",
    region: "Région / Province",
    zip: "Code postal",
    saveChanges: "Enregistrer les modifications",
    saveAndRetry: "Enregistrer et réessayer",
  },

  deleteModal: {
    title: "Supprimer la facture",
    desc: "Cette tentative de facture sera supprimée. Le client pourra demander à nouveau la facture depuis le début.",
    noticeIrreversible: "Cette action est irréversible.",
  },

  emit: {
    title: "Confirmer et émettre la facture",
    subtitle: "Elle est officiellement enregistrée",
    desc: "Vous êtes sur le point d'émettre la facture pour {name}.",
    stepNumberEstimate: "Le numéro séquentiel <b>{code}</b> lui est attribué — le premier à émettre l'obtient.",
    stepNumberFinal: "Le numéro séquentiel <b>définitif</b> lui est attribué — le premier à émettre l'obtient.",
    stepPdf: "Le PDF fiscal est généré et transmis à l'administration fiscale.",
    warn: "Une fois émise, elle <b>ne peut plus être modifiée</b>. En cas d'erreur, vous devrez <b>l'annuler et créer une nouvelle facture</b> (avoir ou facture rectificative).",
    confirm: "Confirmer et émettre",
  },

  newInvoice: {
    title: "Créer une autre facture",
    subtitle: "Pour cette même réservation",
    desc: "Un <strong>nouveau brouillon</strong> s'ouvrira pour cette réservation.",
    step1: "Elle n'inclura <b>que les nouveaux frais</b> que vous ajoutez — l'hébergement déjà facturé n'est pas répété.",
    step2: "Elle reprend les mêmes informations du client. Le numéro est attribué à l'émission.",
    createDraft: "Créer le brouillon",

    // Facturar toda la reserva o una sola habitación (reservas de varias).
    scopeTitle: "Comment facturer ?",
    whole: "Toute la réservation",
    wholeHint: "Une seule facture avec les {n} chambres.",
    perRoom: "Une chambre",
    perRoomHint: "Chaque chambre, sa facture. Quand chaque client paie sa part.",
    pickRoom: "Choisissez la chambre",
    roomLodging: "Hébergement",
    alreadyInvoiced: "déjà facturée",
  },

  correction: {
    doneTitle: "Facture rectificative émise",
    createdOk: "Facture rectificative <strong>{code}</strong> créée avec succès",
    originalKept: "La facture d'origine est conservée comme référence fiscale (elle n'est pas supprimée)",
    pdfSoon: "Le PDF sera généré sous peu",
    title: "Rectifier la facture",
    infobox: "Une <strong>facture rectificative</strong> sera émise pour remplacer fiscalement <strong>{code}</strong> et inclure les frais actuels de la réservation. Le numéro d'origine ne peut pas être modifié (c'est la loi).",
    reasonLabel: "Motif de la rectification",
    selectReason: "— Sélectionnez un motif —",
    reasonTaxId: "NIF / CIF ou identifiant fiscal incorrect",
    reasonName: "Nom ou raison sociale incorrect",
    reasonAddress: "Adresse fiscale incorrecte",
    reasonEmail: "E-mail incorrect",
    reasonGeneral: "Correction générale des informations fiscales",
    reasonOther: "Autre (précisez le motif)",
    customReasonPlaceholder: "Décrivez le motif de la rectification…",
    recipientDivider: "Informations du destinataire — ne modifiez que ce que vous devez corriger",
    nameOrLegalName: "Nom / Raison sociale",
    taxIdFull: "NIF / CIF / Identifiant fiscal / Passeport",
    countryTwoLetters: "(2 lettres)",
    paymentDivider: "Mode de paiement",
    paymentLabel: "Type de paiement",
    paymentUnspecified: "— Non spécifié —",
    paymentCash: "Espèces",
    paymentCard: "Carte de crédit / débit",
    paymentTransfer: "Virement bancaire",
    paymentStripe: "Stripe (en ligne)",
    emitRectif: "Émettre la facture rectificative",
  },

  request: {
    typeCompany: "Entreprise",
    typeIndividual: "Particulier",
    type: "Type",
    legalName: "Raison sociale / Nom",
    taxId: "NIF / CIF",
    address: "Adresse",
    postalCode: "Code postal",
    city: "Ville",
    state: "Province",
    country: "Pays",
    email: "E-mail",
  },

  toast: {
    linkSent: "Lien de facturation envoyé au client via WhatsApp.",
    alreadyIssued: "Cette réservation possède déjà une facture émise.",
    cantSendLink: "Le lien n'a pas pu être envoyé.",
    linkCopied: "Lien copié dans le presse-papiers.",
    alreadyHasInvoice: "Cette réservation possède déjà une facture.",
    cantGenerateLink: "Le lien n'a pas pu être généré.",
    cantSendWhatsapp: "L'envoi via WhatsApp a échoué.",
    invoiceSentWhatsapp: "Facture envoyée via WhatsApp.",
    draftCreatedNewCharges: "Brouillon créé avec les nouveaux frais (sans répéter l'hébergement). Vérifiez-le et émettez-le.",
    draftCreated: "Brouillon créé. Ajoutez des frais et émettez-le lorsqu'il est prêt.",
    alreadyInProgress: "Cette réservation a déjà une facture en cours.",
    cantCreateDraft: "Le brouillon n'a pas pu être créé.",
    invoiceEmitted: "Facture émise. Génération du numéro et du PDF…",
    cantEmit: "La facture n'a pas pu être émise.",
    cantPreview: "L'aperçu n'a pas pu être généré.",
    quoteSent: "Devis envoyé à {email}",
    cantSendQuote: "Impossible d'envoyer le devis",
    cantSync: "Le statut n'a pas pu être synchronisé.",
    retrying: "Nouvelle tentative d'émission…",
    cantRetry: "La nouvelle tentative a échoué.",
    cantVoid: "Erreur lors de l'annulation de la facture.",
    savedCheckFiscal: "Enregistré. Vérifiez le document fiscal.",
    dataUpdated: "Informations mises à jour.",
    cantSaveData: "Les informations n'ont pas pu être enregistrées.",
    invoiceDeleted: "Facture supprimée.",
    cantDelete: "La suppression a échoué.",
    cantEmitRectif: "Erreur lors de l'émission de la facture rectificative.",
  },
};
